class MCartRemoveButton extends HTMLElement {
  constructor() {
    super(),
      this.addEventListener("click", (t) => {
        t.preventDefault(),
          (
            this.closest("m-cart") || this.closest("m-cart-drawer-items")
          ).updateQuantity(this.dataset.index, 0);
      });
  }
}
customElements.define("m-cart-remove-button", MCartRemoveButton);
class MCartTemplate extends HTMLElement {
  constructor() {
    super(),
      (this.cartUpdateUnsubscriber = void 0),
      (this.isCartPage = "cart" === MinimogSettings.templateName),
      (this.cartDrawerWrapper = document.querySelector("m-cart-drawer")),
      (this.cartDrawerInner = document.querySelector(".m-cart-drawer__inner")),
      (this.mainCartItems = this.querySelector("[data-minimog-cart-items]")),
      (this.cartSubTotal = this.querySelector("[data-cart-subtotal]")),
      (this.cartSubTotalPrice = this.querySelector(
        "[data-cart-checkout-subtotal-price]"
      )),
      (this.cartSlidePopup = this.querySelector(
        "#coupon-code-popup-cart-page .content-box"
      )),
      (this.cartDiscount = this.querySelector("[data-minimog-cart-discounts]")),
      (this.cartBreakdownButton = this.querySelector("[shipping-text-toggle]")),
      (this.cartBreakdownContent = this.querySelector(
        "[shipping-text-toggle-content]"
      )),
      (this.giftWrapping = this.querySelector("[data-minimog-gift-wrapping]"));
    let t = this.cartDrawerInner;
    this.isCartPage && (t = document.body),
      (this.loading = new MinimogLibs.AnimateLoading(t, { overlay: t })),
      (this.rootUrl = window.Shopify.routes.root);
    const e = debounce((t) => {
      "id" !== t.target.name && this.onChange(t);
    }, 300);
    this.isCartPage
      ? this.mainCartItems.addEventListener("change", e.bind(this))
      : this.addEventListener("change", e.bind(this)),
      MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, (t) => {
        this.getCart().then((t) => {
          this.updateCartCount(t.item_count);
        });
      }),
      this.cartBreakdownButton &&
        this.cartBreakdownButton.addEventListener("click", () => {
          this.cartBreakdownButton.classList.toggle("open"),
            this.querySelector(
              "[shipping-text-toggle-content]"
            ).classList.toggle("m:hidden");
        });
  }
  updateCartCount(t) {
    document
      .querySelectorAll("[m-cart-count-not-hidden]")
      .forEach((e) => (e.textContent = t)),
      document.querySelectorAll(".m-cart-count-bubble").forEach((e) => {
        t > 0
          ? ((e.textContent = t), e.classList.remove("m:hidden"))
          : e.classList.add("m:hidden");
      });
  }
  getCart() {
    return fetchJSON(this.rootUrl + "cart.json");
  }
  connectedCallback() {
    this.cartUpdateUnsubscriber = MinimogEvents.subscribe(
      MinimogTheme.pubSubEvents.cartUpdate,
      (t) => {
        "main-cart-items" !== t.source && this.onCartUpdate();
      }
    );
  }
  disconnectedCallback() {
    this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber();
  }
  onCartUpdate(t = !0) {
    console.log("hii");
    const { routes: e } = window.MinimogSettings;
    fetch(`${e.cart}?section_id=cart-template`)
      .then((t) => t.text())
      .then((e) => {
        const i = new DOMParser().parseFromString(e, "text/html"),
          n = i.querySelector("[data-minimog-cart-items]"),
          r = i.querySelector("[data-cart-subtotal]"),
          o = i.querySelector("[data-minimog-cart-discounts]"),
          c = i.querySelector("[data-minimog-gift-wrapping]"),
          s = i.querySelector("[data-cart-checkout-subtotal-price]"),
          a = i.querySelector("#coupon-code-popup-cart-page .content-box"),
          u = i.querySelector("[shipping-text-toggle-content]");
        console.log(this.cartSubTotalPrice, a, s, u),
          this.isCartPage &&
            ((this.mainCartItems.innerHTML = n.innerHTML),
            t &&
              ((this.cartSubTotal.innerHTML = r.innerHTML),
              (this.cartDiscount.innerHTML = o.innerHTML),
              (this.cartBreakdownContent.innerHTML = u.innerHTML),
              (this.cartSubTotalPrice.innerHTML = s.innerHTML),
              (this.cartSlidePopup.innerHTML = a.innerHTML),
              (this.giftWrapping.innerHTML = c.innerHTML)));
      })
      .catch((t) => {});
  }
  onChange(t) {
    this.updateQuantity(
      t.target.dataset.index,
      t.target.value,
      document.activeElement.getAttribute("name")
    );
  }
  updateQuantity(t, e, i) {
    console.log("hii2"), this.loading.start();
    const { routes: n } = window.MinimogSettings,
      r = JSON.stringify({
        line: t,
        quantity: e,
        sections: this.getSectionsToRender().map((t) => t.section),
        sections_url: window.location.pathname,
      });
    fetch(`${n.cart_change_url}`, { ...fetchConfig(), body: r })
      .then((t) => t.text())
      .then((e) => {
        const i = JSON.parse(e);
        console.log(i), this.updateCartCount(i.item_count);
        let n = document.getElementById(`MinimogDrawer-quantity-${t}`);
        this.isCartPage &&
          (n = MinimogTheme.config.mqlMobile
            ? document.querySelector(
                `.MinimogQuantity-${t}.MinimogQuantity-mobile`
              )
            : document.querySelector(
                `.MinimogQuantity-${t}.MinimogQuantity-desktop`
              ));
        const r = document.querySelectorAll(".m-cart-item");
        if (i.errors)
          return (
            this.loading.finish(),
            (n.value = n.getAttribute("value")),
            void this.updateLiveRegions(t, i.errors)
          );
        this.classList.toggle("m-cart--empty", 0 === i.item_count),
          this.cartDrawerWrapper &&
            this.cartDrawerWrapper.classList.toggle(
              "m-cart--empty",
              0 === i.item_count
            ),
          this.getSectionsToRender().forEach((t) => {
            console.log(
              t,
              this.getSectionInnerHTML(i.sections[t.section], t.selector)
            ),
              ((
                document.getElementById(t.id).querySelector(t.selector) ||
                document.getElementById(t.id)
              ).innerHTML = this.getSectionInnerHTML(
                i.sections[t.section],
                t.selector
              ));
          });
        const o = i.items[t - 1] ? i.items[t - 1].quantity : void 0;
        let c = "";
        r.length === i.items.length &&
          o !== parseInt(n.value) &&
          (c =
            void 0 === o
              ? window.MinimogStrings.cartError
              : window.MinimogStrings.quantityError.replace(
                  "{{ quantity }}",
                  o
                )),
          this.updateLiveRegions(t, c),
          MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, {
            ...i,
            source: "m-cart-items",
          });
      })
      .catch(() => {})
      .finally(() => {
        this.loading.finish();
      });
  }
  updateLiveRegions(t, e) {
    let i = document.getElementById(`MinimogCartDrawer-Item-${t}`);
    this.isCartPage && (i = document.getElementById(`MinimogCart-Item-${t}`)),
      "" !== e &&
        i &&
        MinimogTheme.Notification.show({
          target: i,
          type: "warning",
          message: e,
        });
  }
  getSectionInnerHTML(t, e) {
    return new DOMParser().parseFromString(t, "text/html").querySelector(e)
      .innerHTML;
  }
  getSectionsToRender() {
    return [
      {
        id: "MinimogCart",
        section: "cart-template",
        selector: "[data-minimog-cart-items]",
      },
      {
        id: "MinimogCart",
        section: "cart-template",
        selector: "[data-cart-subtotal]",
      },
      {
        id: "MinimogCart",
        section: "cart-template",
        selector: "[data-minimog-cart-discounts]",
      },
      {
        id: "MinimogCart",
        section: "cart-template",
        selector: "[data-minimog-gift-wrapping]",
      },
      {
        id: "MinimogCart",
        section: "cart-template",
        selector: "[shipping-text-toggle-content]",
      },
      {
        id: "MinimogCart",
        section: "cart-template",
        selector: "[checkout-data-cart-subtotal]",
      },
      {
        id: "MinimogCart",
        section: "cart-template",
        selector: ".offers-coupon-list",
      },
    ];
  }
}
customElements.define("m-cart", MCartTemplate);
class MDISCOUNTFORM extends HTMLElement {
  constructor() {
    super(),
      this.addEventListener("submit", this.handleDiscountSubmit.bind(this));
  }
  handleDiscountSubmit(t) {
    t.preventDefault();
    const e = this.querySelector("input").value.trim(),
      i = this.querySelector('[type="submit"]'),
      n = i.querySelector(".apply-text"),
      r = i.querySelector(".loader"),
      o = this.querySelector("[apply-coupon-error]"),
      c = document.querySelector("m-cart-drawer"),
      s = document.querySelector("m-cart");
    e &&
      document
        .querySelector("discount-code-button")
        .applyDiscountCode.call(i, e, n, r, c, o, s);
  }
}
customElements.define("m-discount-form", MDISCOUNTFORM);

class DiscountCodeButton extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.cartDrwaer = document.querySelector("m-cart-drawer")),
      (this.cartPage = document.querySelector("m-cart")),
      (this.discountCode = this.getAttribute("data-coupon-code")),
      this.cartDrwaer &&
        ((this.skipDiscount = this.cartDrwaer.querySelector(
          ".offers-coupon-skip-btn"
        )),
        (this.popupSlide = this.cartDrwaer.querySelector("slide-popup")),
        this.skipDiscount?.addEventListener("click", () => {
          this.popupSlide.close();
        })),
      (this.applyText = this.querySelector(".apply-text")),
      (this.loader = this.querySelector(".loader")),
      this.addEventListener(
        "click",
        this.applyDiscountCode.bind(
          this,
          this.discountCode,
          this.applyText,
          this.loader,
          this.cartDrwaer,
          "",
          this.cartPage
        )
      );
  }
  applyDiscountCode(t, e, i, n, r, o) {
    let c,
      s = !1;
    (e.innerHTML = "Applying.."), i.classList.remove("m:hidden");
    let a =`/discount/${t}?v=${Date.now()}&redirect=/checkout/`;
    console.log(t,a);
    fetch(a)
      .then((t) =>t.text())
      .then((t) => {
        const i = new DOMParser().parseFromString(t, "text/html");
        console.log(i);
      })
      // .then(() => fetch("/payments/config", { method: "GET" }))
      // .then((t) => t.json())
      // .then(
      //   (t) => ((c = btoa(t.paymentInstruments.accessToken)), fetch("/cart.js"))
      // )
      // .then((t) => t.json())
      // .then((e) => {
      //   e.discount_codes.length > 0 &&
      //     e.discount_codes.forEach((t) => {
      //       !1 === t.applicable && (s = !0);
      //     });
      //   let i = {
      //     checkout: {
      //       country: Shopify.country,
      //       discount_code: t,
      //       line_items: e.items,
      //       presentment_currency: Shopify.currency.active,
      //     },
      //   };
      //   return fetch("/wallets/checkouts/", {
      //     headers: {
      //       accept: "*/*",
      //       "cache-control": "no-cache",
      //       authorization: "Basic " + c,
      //       "content-type": "application/json, text/javascript",
      //       pragma: "no-cache",
      //       "sec-fetch-dest": "empty",
      //       "sec-fetch-mode": "cors",
      //       "sec-fetch-site": "same-origin",
      //     },
      //     referrerPolicy: "strict-origin-when-cross-origin",
      //     method: "POST",
      //     mode: "cors",
      //     credentials: "include",
      //     body: JSON.stringify(i),
      //   });
      // })
      // .then((t) => t.json())
      // .then((t) => {
      //   if (t.checkout && t.checkout.discount_codes.length > 0);
      //   else {
      //     if (
      //       (this._this.clearLocalStorage(),
      //       t.checkout?.discount_violations.length > 0)
      //     )
      //       throw new Error(
      //         t.checkout.discount_violations[0].non_applicable_reason
      //       );
      //     if (t?.errors) throw new Error(t.errors.discount.code[0].message);
      //   }
      // })
      .catch((t) => {})
      .finally(() => {
        (e.innerHTML = "Apply"),
          i.classList.add("m:hidden"),
          n && n.onCartDrawerUpdate(),
          o && o.onCartUpdate(),
          s &&
            r &&
            (r.classList.remove("m:hidden"),
            setTimeout(() => {
              r.classList.add("m:hidden");
            }, 3e3));
      });
  }
}
customElements.define("discount-code-button", DiscountCodeButton);
